// extracted by mini-css-extract-plugin
export var active = "_8a-a";
export var activeIndicator = "_8a-8";
export var animate = "_8a-9";
export var disabled = "_8a-b";
export var fullWidth = "_8a-2";
export var lg = "_8a-7";
export var md = "_8a-6";
export var redoButtonTabGroup = "_8a-0";
export var sm = "_8a-5";
export var tabButton = "_8a-3";
export var tabButtonsContainer = "_8a-1";
export var xs = "_8a-4";